var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ExistentUser d-flex justify-content-center" },
    [
      _c("div", { staticClass: "banderaSvg" }),
      _c("div", { staticClass: "Content" }, [
        _c("div", { staticClass: "CardWhite" }, [
          _c(
            "div",
            {
              staticClass:
                "box-dk mb-0 pb-4 px-5 text-center d-flex justify-content-start container-text-top"
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "81",
                    height: "78",
                    viewbox: "0 0 81 78",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M80.1181 49.8162C80.1224 55.354 78.4836 60.7686 75.4091 65.3747C72.3347 69.9807 67.9629 73.5711 62.847 75.6913C57.7311 77.8115 52.1012 78.3663 46.6699 77.2854C41.2386 76.2045 36.25 73.5365 32.3357 69.6191C28.4214 65.7018 25.7572 60.7111 24.6805 55.279C23.6038 49.8468 24.163 44.2173 26.2872 39.1031C28.4114 33.9889 32.0051 29.6198 36.6135 26.549C41.2219 23.4781 46.6378 21.8435 52.1756 21.8521C59.5884 21.8578 66.6957 24.8066 71.9353 30.0503C77.1749 35.2939 80.1181 42.4034 80.1181 49.8162Z",
                      fill: "#B5DC68"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M46.3497 16.75C46.3542 19.6727 45.4916 22.531 43.871 24.9633C42.2505 27.3956 39.9449 29.2925 37.246 30.4141C34.5471 31.5356 31.5761 31.8314 28.7091 31.2639C25.842 30.6965 23.2077 29.2913 21.1394 27.2262C19.0712 25.1611 17.662 22.529 17.0902 19.6628C16.5184 16.7966 16.8096 13.8252 17.927 11.1245C19.0445 8.42389 20.9379 6.11539 23.3677 4.49117C25.7975 2.86694 28.6545 2 31.5772 2C35.4912 2 39.2452 3.55326 42.015 6.31878C44.7847 9.0843 46.3437 12.836 46.3497 16.75V16.75Z",
                      stroke: "#001698",
                      "stroke-width": "4",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M2.01126 61.023C1.90234 57.0819 2.58452 53.159 4.01748 49.486C5.45045 45.813 7.60512 42.4646 10.3542 39.6385C13.1032 36.8124 16.3909 34.5661 20.0228 33.0322C23.6548 31.4983 27.5574 30.708 31.5 30.708C35.4426 30.708 39.3452 31.4983 42.9772 33.0322C46.6091 34.5661 49.8968 36.8124 52.6458 39.6385C55.3949 42.4646 57.5496 45.813 58.9825 49.486C60.4155 53.159 61.0977 57.0819 60.9887 61.023H2.01126Z",
                      stroke: "#001698",
                      "stroke-width": "4",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              ),
              _c(
                "h4",
                {
                  staticClass:
                    "textHero mb-2 m-0 ml-3 boldLabel d-flex align-items-center"
                },
                [_vm._v("Confírmanos tus datos")]
              )
            ]
          ),
          _c("div", { staticClass: "px-5" }, [
            _c("p", [
              _c("strong", { staticClass: "boldLabel boldName" }, [
                _vm._v("Nombre:")
              ]),
              _c("span", { staticClass: "ml-1 textFonter pl-3" }, [
                _vm._v(_vm._s(_vm.fullname))
              ])
            ]),
            _c("p", { staticClass: "text-2" }, [
              _c("strong", { staticClass: "boldLabel boldDoc" }, [
                _vm._v("Documento:")
              ]),
              _c("span", { staticClass: "ml-1 textFonter pl-3" }, [
                _vm._v(_vm._s(_vm.docType))
              ])
            ]),
            _c("p", { staticClass: "text-3" }, [
              _c("strong", { staticClass: "boldLabel boldNumber" }, [
                _vm._v("Número:")
              ]),
              _c("span", { staticClass: "ml-1 textFonter pl-3" }, [
                _vm._v(_vm._s(_vm.docNumber))
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "mx-auto text-center" }, [
          _c(
            "button",
            {
              staticClass: "text-center buttonService d-block mx-auto",
              on: { click: _vm.onGoUserView }
            },
            [_c("span", [_vm._v("Confirmar")])]
          ),
          _c(
            "button",
            {
              staticClass:
                "text-center button-without-styles outlinedServiceButton mr-4",
              on: { click: _vm.onGoToCurrentUser }
            },
            [_c("span", [_vm._v("No son mis datos")])]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }